export  enum CategoriaTipoComplemento {
  IDENTIFICADOR = <any> 'IDENTIFICADOR',
  TABELADO = <any> 'TABELADO',
  LIVRE = <any> 'LIVRE'
}

